var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trigger-form-container flex-centerize flex-wrap"},_vm._l((_vm.formItems),function(formItem,i){return _c('div',{key:i,staticClass:"form-item col-12"},[_c(formItem.component,_vm._g(_vm._b({tag:"component"},'component',formItem.props,false),formItem.listeners))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }